import KTween from '../core/KTween';


class WindowScroll
{
	_scrollY = 0;
	get scrollY() { return window.scrollY };
	set scrollY(value) {
		this._scrollY = value;
		window.scrollTo(window.scrollX, this._scrollY);
	};
}
export default class Router
{
	private static _inited = false;
	private static _windowScroll = new WindowScroll();

	static _routesId = {};
	static _scrollable = {};
	static _breadcrumbs = {};
	static _validRoutes = [];
	static _parentPaths = {};
	static _showBreadcrumb = {};
	static get inited(){
		return this._inited;
	}
	static init(routes)
	{
		if(this._inited) return;
		this._inited = true;

		this._parseRoutes(routes);
	}

	private static _parseRoutes(routes, parentPath = '')
	{
		let path;
		for(let [k, v] of Object.entries(routes))
		{
			path = '/' + parentPath + '/' + k + '/';
			path = path.replace(/\/+/g, '/');
			this._validRoutes.push(path);
			if(v['id']) this._routesId[v['id']] = path;
			this._scrollable[path] = (v['wrapRouter'] === false);
			this._parentPaths[path] = parentPath;
			let showBreadcrumb = true;
			if(v.hasOwnProperty('showBreadcrumb')) showBreadcrumb = v['showBreadcrumb'];
			this._showBreadcrumb[path] = showBreadcrumb;
			let breadcrumb = v['breadcrumb'];
			if(!breadcrumb) breadcrumb = path.replace(/^.*?([^\/]+)\/$/, '$1');
			this._breadcrumbs[path] = breadcrumb;
			if(v['routes'])
			{
				this._parseRoutes(v['routes'], path);
			}
		}
	}

	static isValid(path)
	{
		path = (path + '/').replace(/\/+/g, '/');
		return this._validRoutes.indexOf(path) >= 0;
	}
	
	static getByID(id:string)
	{
		if(!this._inited) throw new Error('Router was not initialized');
		return this._routesId[id];
	}

	static showBreadcrumb(path)
	{
		if(!this._inited) throw new Error('Router was not initialized');
		return this._showBreadcrumb[path];
	}

	static routeScrollable(path:string)
	{
		if(!this._inited) throw new Error('Router was not initialized');
		return this._scrollable[path];
	}

	static parentRoute(path:string)
	{
		if(!this._inited) throw new Error('Router was not initialized');
		return this._parentPaths[path];
	}

	static breadcrumb(path:string)
	{
		let parts = [];
		path = (path + '/').replace(/\/+/g, '/');

		let c = 10;
		while(c-- > 0 && (this._validRoutes.indexOf(path) < 0) && path.length > 1){
			path = path.replace(/^.*?([^\/]+)\/$/, '');
		}
		c = 10;
		while(c-- > 0 && path.length > 0)
		{
			let part = this._breadcrumbs[path];
			if(!part)
			{
				part = path.replace(/^.*?([^\/]+)\/$/, '$1')
			}
			parts.push({label: part, path: path});
			path = path.replace(/([^\/]*)\/$/, '');
		}
		parts = parts.reverse();
		return parts;
	}

	static scrollTop()
	{
		KTween.tween(this._windowScroll, {scrollY: 0}, 'easeInOutQuart', 0.6);
	}
}
